<script>
  // Перенос src_ui/web/src/screens/Appearance.tsx — дословно (те же списки, та же логика,
  // тот же троттлинг отправки 50мс и стартовый пакет при открытии).
  import { onDestroy } from 'svelte';
  import { nuiPost } from './nui';
  import { defaultAppearance } from './types';
  import Wiz from './wiz.svelte';

  export let gender = 'm';
  export let error = '';
  export let clearError = () => {};
  export let onBack = () => {};
  export let onFinish = () => {};

  const SECTIONS = [
    { id: 'heritage', label: 'Наследие' },
    { id: 'face', label: 'Лицо' },
    { id: 'hair', label: 'Волосы' },
    { id: 'eyes', label: 'Глаза' },
    { id: 'outfit', label: 'Одежда' },
  ];

  const FEATURES = [
    { idx: 0, label: 'Ширина носа', left: 'узкий', right: 'широкий' },
    { idx: 1, label: 'Высота носа', left: 'низкий', right: 'высокий' },
    { idx: 2, label: 'Кончик носа', left: 'короткий', right: 'длинный' },
    { idx: 3, label: 'Горбинка носа', left: 'нет', right: 'сильная' },
    { idx: 4, label: 'Наклон кончика', left: 'вверх', right: 'вниз' },
    { idx: 6, label: 'Брови', left: 'ниже', right: 'выше' },
    { idx: 8, label: 'Скулы', left: 'ниже', right: 'выше' },
    { idx: 9, label: 'Ширина скул', left: 'уже', right: 'шире' },
    { idx: 10, label: 'Щёки', left: 'впалые', right: 'полные' },
    { idx: 11, label: 'Разрез глаз', left: 'прищур', right: 'открытые' },
    { idx: 12, label: 'Губы', left: 'тонкие', right: 'полные' },
    { idx: 13, label: 'Челюсть', left: 'уже', right: 'шире' },
    { idx: 16, label: 'Подбородок', left: 'короче', right: 'длиннее' },
    { idx: 19, label: 'Шея', left: 'тонкая', right: 'широкая' },
  ];

  const HAIR_COLORS = [
    '#0a0a0a', '#16100b', '#221710', '#2e1f14', '#3a2a1a', '#46331f', '#523c24', '#5e462a', '#6b5130',
    '#7d5f38', '#8f7042', '#a3854f', '#b89a5e', '#cdb073', '#e0c789', '#b0552c', '#8c3b1f', '#a9a9a9',
  ];

  const EYE_COLORS = [
    { id: 0, c: '#3a7d44', name: 'зелёный' }, { id: 1, c: '#2e8b6e', name: 'изумрудный' },
    { id: 2, c: '#7ec8e3', name: 'голубой' }, { id: 3, c: '#2a5db0', name: 'синий' },
    { id: 4, c: '#a86b32', name: 'светло-карий' }, { id: 5, c: '#5b3a1e', name: 'тёмно-карий' },
    { id: 6, c: '#8a7035', name: 'ореховый' }, { id: 7, c: '#4a4f55', name: 'тёмно-серый' },
    { id: 8, c: '#9aa3ab', name: 'светло-серый' },
  ];

  const OUTFITS_UI = [
    // «Деловой» убран по слову владельца (2026-08-01) — стартовые стили только кэжуал и уличный.
    { name: 'Кэжуал', icon: '👕' },
    { name: 'Уличный', icon: '🧢' },
  ];

  // Причёски — РОВНО тот же список, что в парикмахерской (src_client/shop/barber/data.js).
  const HAIR_IDS = {
    m: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
      20, 21, 22, 30, 31, 32, 33, 34, 73, 41, 79, 80, 81, 82, 84, 85, 89, 74,
      91, 94, 98, 99, 108, 109, 110, 75, 90, 92, 93, 95, 97, 101, 102, 103,
      105, 106, 107, 111, 112, 113, 114, 115, 116, 77, 78, 83, 100, 104,
    ],
    f: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
      20, 21, 22, 31, 32, 33, 34, 76, 77, 95, 96, 97, 98, 99, 94, 79, 80, 82,
      84, 85, 86, 100, 101, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
      113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 81, 83, 87, 88, 89,
      90, 91, 92, 93, 102,
    ],
  };
  const MOM = { min: 21, max: 45 };
  const DAD = { min: 0, max: 20 };

  let app = defaultAppearance(gender);
  let section = 'heritage';
  let camFace = false;

  $: hairIds = HAIR_IDS[gender];
  $: hairPos = Math.max(0, hairIds.indexOf(Number(app.hair) || 0));

  // Внешность уходила на клиент только при ПЕРВОМ изменении — до этого человек
  // видел голого педа без причёски. Отправляем стартовый набор сразу при открытии.
  nuiPost('appearance', app);

  // орбита мышью: тянешь — камера летит вокруг персонажа
  const drag = { on: false, x: 0, y: 0, dx: 0, dy: 0, t: null };

  const flushOrbit = () => {
    drag.t = null;
    if (drag.dx || drag.dy) {
      nuiPost('orbit', { dx: drag.dx, dy: drag.dy });
      drag.dx = 0;
      drag.dy = 0;
    }
  };

  const onOrbitMove = (e) => {
    if (!drag.on) return;
    drag.dx += e.clientX - drag.x;
    drag.dy += e.clientY - drag.y;
    drag.x = e.clientX;
    drag.y = e.clientY;
    if (drag.t === null) drag.t = window.setTimeout(flushOrbit, 30);
  };

  // отправка изменений с троттлингом 50мс — дословно push() из React
  let timer = null;
  let pending = app;
  const push = (next) => {
    app = next;
    pending = next;
    if (timer === null) {
      timer = window.setTimeout(() => {
        timer = null;
        nuiPost('appearance', pending);
      }, 50);
    }
  };
  onDestroy(() => { if (timer !== null) clearTimeout(timer); if (drag.t !== null) clearTimeout(drag.t); });

  const set = (patch) => push({ ...app, ...patch });

  const setFeature = (idx, v) => {
    const features = [...app.features];
    features[idx] = v;
    push({ ...app, features });
  };

  const cycle = (v, min, max, dir) => {
    const span = max - min + 1;
    return min + (((v - min + dir) % span) + span) % span;
  };

  const randomize = () => {
    const rnd = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
    const features = app.features.map((_, i) =>
      FEATURES.some((f) => f.idx === i) ? Math.round((Math.random() * 1.2 - 0.6) * 100) / 100 : 0,
    );
    push({
      ...app,
      mom: rnd(MOM.min, MOM.max),
      dad: rnd(DAD.min, DAD.max),
      faceMix: Math.round(Math.random() * 100) / 100,
      skinMix: Math.round(Math.random() * 100) / 100,
      features,
      hair: hairIds[rnd(0, hairIds.length - 1)],
      hairColor: rnd(0, HAIR_COLORS.length - 1),
      hairHighlight: rnd(0, HAIR_COLORS.length - 1),
      eyeColor: rnd(0, EYE_COLORS.length - 1),
      outfit: rnd(0, OUTFITS_UI.length - 1),
    });
  };

  const finish = () => {
    clearError();
    onFinish(OUTFITS_UI[app.outfit]?.name ?? 'Кэжуал');
    nuiPost('finish');
  };
</script>

<div
  class="orbit-zone"
  on:mousedown={(e) => { drag.on = true; drag.x = e.clientX; drag.y = e.clientY; }}
  on:mouseup={() => { drag.on = false; }}
  on:mouseleave={() => { drag.on = false; }}
  on:mousemove={onOrbitMove}
  on:wheel={(e) => nuiPost('zoom', { delta: e.deltaY })}
></div>
<div class="hint">🖱 Зажми и тяни — камера вокруг персонажа · колесо — зум</div>

<Wiz step={2} {error} onBack={onBack} nextLabel="Войти в город" onNext={finish}>
  <div class="wizbody">
    <div class="tabs">
      {#each SECTIONS as s (s.id)}
        <div
          class={'tabbtn' + (section === s.id ? ' on' : '')}
          on:click={() => { section = s.id; }}
        >
          {s.label}
        </div>
      {/each}
    </div>

    <div class="scrollarea">
      {#if section === 'heritage'}
        <div class="pickrow">
          <div class="pbtn" on:click={() => set({ mom: cycle(app.mom, MOM.min, MOM.max, -1) })}>‹</div>
          <div class="pmid">
            <div class="pv">Лицо №{app.mom}</div>
            <div class="pl">Мама · 21–45</div>
          </div>
          <div class="pbtn" on:click={() => set({ mom: cycle(app.mom, MOM.min, MOM.max, 1) })}>›</div>
        </div>
        <div class="pickrow">
          <div class="pbtn" on:click={() => set({ dad: cycle(app.dad, DAD.min, DAD.max, -1) })}>‹</div>
          <div class="pmid">
            <div class="pv">Лицо №{app.dad}</div>
            <div class="pl">Папа · 0–20</div>
          </div>
          <div class="pbtn" on:click={() => set({ dad: cycle(app.dad, DAD.min, DAD.max, 1) })}>›</div>
        </div>
        {#each [
          { label: 'Черты лица', left: 'мама', right: 'папа', key: 'faceMix' },
          { label: 'Тон кожи', left: 'мама', right: 'папа', key: 'skinMix' },
        ] as sb (sb.key)}
          <div class="sliderblock">
            <div class="head">
              <span class="lab">{sb.label}</span>
              <span class="val">{(app[sb.key] > 0 ? '+' : '') + app[sb.key].toFixed(2)}</span>
            </div>
            <input class="rng" type="range" min="0" max="1" step="0.01" value={app[sb.key]}
              on:input={(e) => set({ [sb.key]: Number(e.target.value) })} />
            <div class="ends"><span>{sb.left}</span><span>{sb.right}</span></div>
          </div>
        {/each}
      {/if}

      {#if section === 'face'}
        {#each FEATURES as f (f.idx)}
          <div class="sliderblock">
            <div class="head">
              <span class="lab">{f.label}</span>
              <span class="val">{((app.features[f.idx] ?? 0) > 0 ? '+' : '') + (app.features[f.idx] ?? 0).toFixed(2)}</span>
            </div>
            <input class="rng" type="range" min="-1" max="1" step="0.05" value={app.features[f.idx] ?? 0}
              on:input={(e) => setFeature(f.idx, Number(e.target.value))} />
            <div class="ends"><span>{f.left}</span><span>{f.right}</span></div>
          </div>
        {/each}
      {/if}

      {#if section === 'hair'}
        <div class="pickrow">
          <div class="pbtn" on:click={() => set({ hair: hairIds[(hairPos - 1 + hairIds.length) % hairIds.length] })}>‹</div>
          <div class="pmid">
            <div class="pv">{`Стиль ${hairPos + 1} / ${hairIds.length}`}</div>
            <div class="pl">Причёска</div>
          </div>
          <div class="pbtn" on:click={() => set({ hair: hairIds[(hairPos + 1) % hairIds.length] })}>›</div>
        </div>
        {#each [
          { label: 'Цвет волос', key: 'hairColor' },
          { label: 'Оттенок / мелирование', key: 'hairHighlight' },
        ] as g (g.key)}
          <div>
            <div class="swhead">{g.label}</div>
            <div class="swgrid">
              {#each HAIR_COLORS as c, i (i)}
                <div
                  class={'sw' + (i === app[g.key] ? ' on' : '')}
                  style="background:{c}"
                  on:click={() => set({ [g.key]: i })}
                ></div>
              {/each}
            </div>
          </div>
        {/each}
      {/if}

      {#if section === 'eyes'}
        <div>
          <div class="swhead">
            Цвет глаз — <span class="gold">{EYE_COLORS[app.eyeColor]?.name ?? ''}</span>
          </div>
          <div class="swgrid">
            {#each EYE_COLORS as e (e.id)}
              <div
                class={'sw' + (app.eyeColor === e.id ? ' on' : '')}
                style="background:radial-gradient(circle at 35% 35%, {e.c}, {e.c} 55%, rgba(0,0,0,0.45));border-radius:9px"
                on:click={() => set({ eyeColor: e.id })}
              ></div>
            {/each}
          </div>
        </div>
      {/if}

      {#if section === 'outfit'}
        <div>
          <div class="swhead">Стартовый комплект</div>
          <div class="outfit3">
            {#each OUTFITS_UI as o, i (i)}
              <div
                class={'ocard' + (app.outfit === i ? ' on' : '')}
                on:click={() => set({ outfit: i })}
              >
                <div class="ic">{o.icon}</div>
                <div class="nm">{o.name}</div>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>

    <div class="bodybar">
      <div class="iconbtn" title="Повернуть влево" on:click={() => nuiPost('rotate', { dir: 'left' })}>⟲</div>
      <div class="iconbtn" title="Повернуть вправо" on:click={() => nuiPost('rotate', { dir: 'right' })}>⟳</div>
      <div class="caml">Камера</div>
      <div class="camseg">
        <div
          class={'seg' + (camFace ? ' on' : '')}
          on:click={() => { camFace = true; nuiPost('camMode', { mode: 'face' }); }}
        >
          Лицо
        </div>
        <div
          class={'seg' + (!camFace ? ' on' : '')}
          on:click={() => { camFace = false; nuiPost('camMode', { mode: 'body' }); }}
        >
          Тело
        </div>
      </div>
      <div class="iconbtn" title="Случайная внешность" on:click={randomize}>🎲</div>
    </div>
  </div>
</Wiz>
